import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCopy = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.625 3.5h-14a.875.875 0 0 0-.875.875V8.75H4.375a.875.875 0 0 0-.875.875v14a.875.875 0 0 0 .875.875h14a.875.875 0 0 0 .875-.875V19.25h4.375a.875.875 0 0 0 .875-.875v-14a.875.875 0 0 0-.875-.875ZM17.5 22.75H5.25V10.5H17.5v12.25Zm5.25-5.25h-3.5V9.625a.875.875 0 0 0-.875-.875H10.5v-3.5h12.25V17.5Z" />
  </svg>
);
export default SvgCopy;
